import relay from './components/relay.vue';

import type { RelayItem } from './types/relay.d';
import { initRelayDataAndFormat, transformRelayFormat } from './utils/device-relay';

export { RelayItem, initRelayDataAndFormat, transformRelayFormat };
export default relay;
